import React from 'react';
import styles from './index.module.scss';
import { useI18n } from '@/pages/business/_contexts/I18nContext';
import { publicPath } from '@/utils';

const OutstandingPartners = ({
  cases
}) => {
  const I18n = useI18n();
  cases.sort((a, b) => {
    var _a, _b;

    return ((_a = a.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()) > ((_b = b.name) === null || _b === void 0 ? void 0 : _b.toUpperCase()) ? 1 : -1;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, I18n.t('tts_portal_outstanding_partners_list_title')), /*#__PURE__*/React.createElement("p", {
    className: styles.tips
  }, I18n.t('tts_portal_outstanding_partners_list_desc')), /*#__PURE__*/React.createElement("div", {
    className: styles.partnersContainer
  }, cases.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.name,
    className: styles.partner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.partnerImg
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: item.image,
    onError: e => e.currentTarget.src = publicPath('/images/business/error/error-pic.png')
  }))), /*#__PURE__*/React.createElement("p", null, item.name))))));
};

export default OutstandingPartners;